import { MutationCache, QueryClient } from "@tanstack/react-query";

import { HttpError } from "../api";
import { publishToast } from "../toast";

export function shouldRetryQuery(
  failureCount: number,
  error: unknown,
): boolean {
  if (
    error instanceof HttpError &&
    error.status !== undefined &&
    error.status >= 400 &&
    error.status < 500
  ) {
    return false;
  }

  return failureCount < 3;
}

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    mutationCache: new MutationCache({
      onError: (error) => {
        const message =
          error instanceof Error && error.message.length > 0
            ? error.message
            : "An unexpected error occurred.";
        publishToast({
          kind: "error",
          title: message,
        });
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: shouldRetryQuery,
        refetchOnWindowFocus: false,
      },
      // Default `networkMode: "online"` pauses a mutation entirely while
      // `navigator.onLine` is false, then fires it for the first time once
      // connectivity returns -- so a Save click while offline never even
      // reaches the HTTP client (nothing in the Network tab, no error, no
      // timeout -- it's not running yet). "always" makes it actually attempt
      // the call, so a dead connection fails through the normal HTTP-layer
      // timeout/error path instead of silently queuing.
      mutations: { retry: false, networkMode: "always" },
    },
  });
}
